import {
  Duration5ynfiptaqcrg as Duration,
  Duration__toString_impl_8d916b11f1kpclwmkpg as Duration__toString_impl_8d916b,
  Duration__hashCode_impl_u4exz629donm5f9ouki as Duration__hashCode_impl_u4exz6,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { DurationSerializer_getInstanceo50ej00g6vz5 as DurationSerializer_getInstance } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/BuiltInSerializers.mjs';
import { ContextualSerializer1uidivg94sh5v as ContextualSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/ContextualSerializer.mjs';
import { Companion_getInstance2nqzk98fbkur7 as Companion_getInstance } from './OtpHashAlgorithm.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance3hlj875zwihx0 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { IndexSet1wbu7in7fosv3 as IndexSet } from '../../../lightningdb/Annotations.mjs';
import { DeferToContextualUuidSerializer_getInstance3t53sgmdyoff4 as DeferToContextualUuidSerializer_getInstance } from '../../../UUID.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Companion_getInstance3n9as6ds1py67 as Companion_getInstance_0 } from '../../../UUID.js.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../../DefaultClock.mjs';
import { InstantIso8601Serializer_getInstance2sfqqbic5n1oz as InstantIso8601Serializer_getInstance } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/InstantSerializers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import {
  StringSerializer_getInstance2wffkbpdux3h9 as StringSerializer_getInstance,
  IntSerializer_getInstance2q7s8kvk1il5u as IntSerializer_getInstance,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  equals2au1ep9vhcato as equals,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { HasId2loj0ucxxxo6d as HasId } from '../../../lightningdb/HasId.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function OtpSecret$Companion$$childSerializers$_anonymous__onmcep() {
  var tmp = getKClass(Duration());
  var tmp_0 = DurationSerializer_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  return ContextualSerializer().zy(tmp, tmp_0, tmp$ret$2);
}
function OtpSecret$Companion$$childSerializers$_anonymous__onmcep_0() {
  return Companion_getInstance().m2a();
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, OtpSecret$Companion$$childSerializers$_anonymous__onmcep);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.i2r_1 = [null, null, null, null, null, null, tmp_1, null, lazy(tmp_2, OtpSecret$Companion$$childSerializers$_anonymous__onmcep_0), null, null, null, null];
      }
      m2a() {
        return $serializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance_1() {
  if (Companion_instance_0 === VOID)
    new (Companion())();
  return Companion_instance_0;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.auth.proof.OtpSecret', this, 13);
        tmp0_serialDesc.c1b('_id', true);
        tmp0_serialDesc.c1b('subjectType', false);
        tmp0_serialDesc.c1b('subjectId', false);
        tmp0_serialDesc.c1b('label', false);
        tmp0_serialDesc.c1b('secretBase32', false);
        tmp0_serialDesc.c1b('issuer', false);
        tmp0_serialDesc.c1b('period', false);
        tmp0_serialDesc.c1b('digits', false);
        tmp0_serialDesc.c1b('algorithm', false);
        tmp0_serialDesc.c1b('establishedAt', true);
        tmp0_serialDesc.c1b('lastUsedAt', true);
        tmp0_serialDesc.c1b('expiresAt', true);
        tmp0_serialDesc.c1b('disabledAt', true);
        tmp0_serialDesc.e1b(new (IndexSet())(['subjectId', 'subjectType', 'expiresAt', 'disabledAt']));
        this.r4e_1 = tmp0_serialDesc;
      }
      s4e(encoder, value) {
        var tmp0_desc = this.r4e_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance_1().i2r_1;
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.p2r_1.equals(Companion_getInstance_0().m2p())) {
          tmp1_output.c15(tmp0_desc, 0, DeferToContextualUuidSerializer_getInstance(), value.p2r_1);
        }
        tmp1_output.a15(tmp0_desc, 1, value.q2r_1);
        tmp1_output.a15(tmp0_desc, 2, value.r2r_1);
        tmp1_output.a15(tmp0_desc, 3, value.s2r_1);
        tmp1_output.a15(tmp0_desc, 4, value.t2r_1);
        tmp1_output.a15(tmp0_desc, 5, value.u2r_1);
        tmp1_output.c15(tmp0_desc, 6, tmp2_cached[6].f2(), new (Duration())(value.v2r_1));
        tmp1_output.v14(tmp0_desc, 7, value.w2r_1);
        tmp1_output.c15(tmp0_desc, 8, tmp2_cached[8].f2(), value.x2r_1);
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 9)) {
          tmp = true;
        } else {
          // Inline function 'com.lightningkite.now' call
          var tmp$ret$0 = get_default(Companion_instance).d1m();
          tmp = !value.y2r_1.equals(tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.c15(tmp0_desc, 9, InstantIso8601Serializer_getInstance(), value.y2r_1);
        }
        if (tmp1_output.h15(tmp0_desc, 10) ? true : !(value.z2r_1 == null)) {
          tmp1_output.d15(tmp0_desc, 10, InstantIso8601Serializer_getInstance(), value.z2r_1);
        }
        if (tmp1_output.h15(tmp0_desc, 11) ? true : !(value.a2s_1 == null)) {
          tmp1_output.d15(tmp0_desc, 11, InstantIso8601Serializer_getInstance(), value.a2s_1);
        }
        if (tmp1_output.h15(tmp0_desc, 12) ? true : !(value.b2s_1 == null)) {
          tmp1_output.d15(tmp0_desc, 12, InstantIso8601Serializer_getInstance(), value.b2s_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.s4e(encoder, value instanceof OtpSecret() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.r4e_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = 0;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_local10 = null;
        var tmp15_local11 = null;
        var tmp16_local12 = null;
        var tmp17_input = decoder.l13(tmp0_desc);
        var tmp18_cached = Companion_getInstance_1().i2r_1;
        if (tmp17_input.a14()) {
          tmp4_local0 = tmp17_input.x13(tmp0_desc, 0, DeferToContextualUuidSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp17_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp17_input.v13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp17_input.v13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp17_input.v13(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp17_input.v13(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          var tmp = tmp18_cached[6].f2();
          var tmp_0 = tmp10_local6;
          var tmp_1 = tmp17_input.x13(tmp0_desc, 6, tmp, tmp_0 == null ? null : new (Duration())(tmp_0));
          tmp10_local6 = tmp_1 == null ? null : tmp_1.nj_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp17_input.q13(tmp0_desc, 7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp17_input.x13(tmp0_desc, 8, tmp18_cached[8].f2(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp17_input.x13(tmp0_desc, 9, InstantIso8601Serializer_getInstance(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
          tmp14_local10 = tmp17_input.z13(tmp0_desc, 10, InstantIso8601Serializer_getInstance(), tmp14_local10);
          tmp3_bitMask0 = tmp3_bitMask0 | 1024;
          tmp15_local11 = tmp17_input.z13(tmp0_desc, 11, InstantIso8601Serializer_getInstance(), tmp15_local11);
          tmp3_bitMask0 = tmp3_bitMask0 | 2048;
          tmp16_local12 = tmp17_input.z13(tmp0_desc, 12, InstantIso8601Serializer_getInstance(), tmp16_local12);
          tmp3_bitMask0 = tmp3_bitMask0 | 4096;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp17_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp17_input.x13(tmp0_desc, 0, DeferToContextualUuidSerializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp17_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp17_input.v13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp17_input.v13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp17_input.v13(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp17_input.v13(tmp0_desc, 5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                var tmp_2 = tmp18_cached[6].f2();
                var tmp_3 = tmp10_local6;
                var tmp_4 = tmp17_input.x13(tmp0_desc, 6, tmp_2, tmp_3 == null ? null : new (Duration())(tmp_3));
                tmp10_local6 = tmp_4 == null ? null : tmp_4.nj_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp17_input.q13(tmp0_desc, 7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp17_input.x13(tmp0_desc, 8, tmp18_cached[8].f2(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp17_input.x13(tmp0_desc, 9, InstantIso8601Serializer_getInstance(), tmp13_local9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              case 10:
                tmp14_local10 = tmp17_input.z13(tmp0_desc, 10, InstantIso8601Serializer_getInstance(), tmp14_local10);
                tmp3_bitMask0 = tmp3_bitMask0 | 1024;
                break;
              case 11:
                tmp15_local11 = tmp17_input.z13(tmp0_desc, 11, InstantIso8601Serializer_getInstance(), tmp15_local11);
                tmp3_bitMask0 = tmp3_bitMask0 | 2048;
                break;
              case 12:
                tmp16_local12 = tmp17_input.z13(tmp0_desc, 12, InstantIso8601Serializer_getInstance(), tmp16_local12);
                tmp3_bitMask0 = tmp3_bitMask0 | 4096;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp17_input.m13(tmp0_desc);
        return OtpSecret().t4e(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, null);
      }
      az() {
        return this.r4e_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance_1().i2r_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [DeferToContextualUuidSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[6].f2(), IntSerializer_getInstance(), tmp0_cached[8].f2(), InstantIso8601Serializer_getInstance(), get_nullable(InstantIso8601Serializer_getInstance()), get_nullable(InstantIso8601Serializer_getInstance()), get_nullable(InstantIso8601Serializer_getInstance())];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var OtpSecretClass;
function OtpSecret() {
  if (OtpSecretClass === VOID) {
    class $ {
      constructor(_id, subjectType, subjectId, label, secretBase32, issuer, period, digits, algorithm, establishedAt, lastUsedAt, expiresAt, disabledAt) {
        Companion_getInstance_1();
        _id = _id === VOID ? Companion_getInstance_0().m2p() : _id;
        var tmp;
        if (establishedAt === VOID) {
          // Inline function 'com.lightningkite.now' call
          tmp = get_default(Companion_instance).d1m();
        } else {
          tmp = establishedAt;
        }
        establishedAt = tmp;
        lastUsedAt = lastUsedAt === VOID ? null : lastUsedAt;
        expiresAt = expiresAt === VOID ? null : expiresAt;
        disabledAt = disabledAt === VOID ? null : disabledAt;
        this.p2r_1 = _id;
        this.q2r_1 = subjectType;
        this.r2r_1 = subjectId;
        this.s2r_1 = label;
        this.t2r_1 = secretBase32;
        this.u2r_1 = issuer;
        this.v2r_1 = period;
        this.w2r_1 = digits;
        this.x2r_1 = algorithm;
        this.y2r_1 = establishedAt;
        this.z2r_1 = lastUsedAt;
        this.a2s_1 = expiresAt;
        this.b2s_1 = disabledAt;
      }
      h40() {
        return this.p2r_1;
      }
      u4e(_id, subjectType, subjectId, label, secretBase32, issuer, period, digits, algorithm, establishedAt, lastUsedAt, expiresAt, disabledAt) {
        return new (OtpSecret())(_id, subjectType, subjectId, label, secretBase32, issuer, period, digits, algorithm, establishedAt, lastUsedAt, expiresAt, disabledAt);
      }
      d2s(_id, subjectType, subjectId, label, secretBase32, issuer, period, digits, algorithm, establishedAt, lastUsedAt, expiresAt, disabledAt, $super) {
        _id = _id === VOID ? this.p2r_1 : _id;
        subjectType = subjectType === VOID ? this.q2r_1 : subjectType;
        subjectId = subjectId === VOID ? this.r2r_1 : subjectId;
        label = label === VOID ? this.s2r_1 : label;
        secretBase32 = secretBase32 === VOID ? this.t2r_1 : secretBase32;
        issuer = issuer === VOID ? this.u2r_1 : issuer;
        period = period === VOID ? this.v2r_1 : period;
        digits = digits === VOID ? this.w2r_1 : digits;
        algorithm = algorithm === VOID ? this.x2r_1 : algorithm;
        establishedAt = establishedAt === VOID ? this.y2r_1 : establishedAt;
        lastUsedAt = lastUsedAt === VOID ? this.z2r_1 : lastUsedAt;
        expiresAt = expiresAt === VOID ? this.a2s_1 : expiresAt;
        disabledAt = disabledAt === VOID ? this.b2s_1 : disabledAt;
        return $super === VOID ? this.u4e(_id, subjectType, subjectId, label, secretBase32, issuer, period, digits, algorithm, establishedAt, lastUsedAt, expiresAt, disabledAt) : $super.u4e.call(this, _id, subjectType, subjectId, label, secretBase32, issuer, new (Duration())(period), digits, algorithm, establishedAt, lastUsedAt, expiresAt, disabledAt);
      }
      toString() {
        return 'OtpSecret(_id=' + this.p2r_1.toString() + ', subjectType=' + this.q2r_1 + ', subjectId=' + this.r2r_1 + ', label=' + this.s2r_1 + ', secretBase32=' + this.t2r_1 + ', issuer=' + this.u2r_1 + ', period=' + Duration__toString_impl_8d916b(this.v2r_1) + ', digits=' + this.w2r_1 + ', algorithm=' + this.x2r_1.toString() + ', establishedAt=' + this.y2r_1.toString() + ', lastUsedAt=' + toString(this.z2r_1) + ', expiresAt=' + toString(this.a2s_1) + ', disabledAt=' + toString(this.b2s_1) + ')';
      }
      hashCode() {
        var result = this.p2r_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.q2r_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.r2r_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.s2r_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.t2r_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.u2r_1) | 0;
        result = imul(result, 31) + Duration__hashCode_impl_u4exz6(this.v2r_1) | 0;
        result = imul(result, 31) + this.w2r_1 | 0;
        result = imul(result, 31) + this.x2r_1.hashCode() | 0;
        result = imul(result, 31) + this.y2r_1.hashCode() | 0;
        result = imul(result, 31) + (this.z2r_1 == null ? 0 : this.z2r_1.hashCode()) | 0;
        result = imul(result, 31) + (this.a2s_1 == null ? 0 : this.a2s_1.hashCode()) | 0;
        result = imul(result, 31) + (this.b2s_1 == null ? 0 : this.b2s_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof OtpSecret()))
          return false;
        if (!this.p2r_1.equals(other.p2r_1))
          return false;
        if (!(this.q2r_1 === other.q2r_1))
          return false;
        if (!(this.r2r_1 === other.r2r_1))
          return false;
        if (!(this.s2r_1 === other.s2r_1))
          return false;
        if (!(this.t2r_1 === other.t2r_1))
          return false;
        if (!(this.u2r_1 === other.u2r_1))
          return false;
        if (!(this.v2r_1 === other.v2r_1))
          return false;
        if (!(this.w2r_1 === other.w2r_1))
          return false;
        if (!this.x2r_1.equals(other.x2r_1))
          return false;
        if (!this.y2r_1.equals(other.y2r_1))
          return false;
        if (!equals(this.z2r_1, other.z2r_1))
          return false;
        if (!equals(this.a2s_1, other.a2s_1))
          return false;
        if (!equals(this.b2s_1, other.b2s_1))
          return false;
        return true;
      }
      static t4e(seen0, _id, subjectType, subjectId, label, secretBase32, issuer, period, digits, algorithm, establishedAt, lastUsedAt, expiresAt, disabledAt, serializationConstructorMarker) {
        Companion_getInstance_1();
        if (!(510 === (510 & seen0))) {
          throwMissingFieldException(seen0, 510, $serializer_getInstance().r4e_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.p2r_1 = Companion_getInstance_0().m2p();
        else
          $this.p2r_1 = _id;
        $this.q2r_1 = subjectType;
        $this.r2r_1 = subjectId;
        $this.s2r_1 = label;
        $this.t2r_1 = secretBase32;
        $this.u2r_1 = issuer;
        $this.v2r_1 = period;
        $this.w2r_1 = digits;
        $this.x2r_1 = algorithm;
        if (0 === (seen0 & 512)) {
          var tmp = $this;
          // Inline function 'com.lightningkite.now' call
          tmp.y2r_1 = get_default(Companion_instance).d1m();
        } else
          $this.y2r_1 = establishedAt;
        if (0 === (seen0 & 1024))
          $this.z2r_1 = null;
        else
          $this.z2r_1 = lastUsedAt;
        if (0 === (seen0 & 2048))
          $this.a2s_1 = null;
        else
          $this.a2s_1 = expiresAt;
        if (0 === (seen0 & 4096))
          $this.b2s_1 = null;
        else
          $this.b2s_1 = disabledAt;
        return $this;
      }
    }
    initMetadataForClass($, 'OtpSecret', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance});
    OtpSecretClass = $;
  }
  return OtpSecretClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance_0();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_1;
function Companion_getInstance_2() {
  return Companion_instance_1;
}
var $serializerClass_0;
function $serializer_0() {
  if ($serializerClass_0 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_0 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.auth.proof.EstablishOtp', this, 1);
        tmp0_serialDesc.c1b('label', true);
        this.v4e_1 = tmp0_serialDesc;
      }
      w4e(encoder, value) {
        var tmp0_desc = this.v4e_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !(value.x4e_1 == null)) {
          tmp1_output.d15(tmp0_desc, 0, StringSerializer_getInstance(), value.x4e_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.w4e(encoder, value instanceof EstablishOtp() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.v4e_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_input = decoder.l13(tmp0_desc);
        if (tmp5_input.a14()) {
          tmp4_local0 = tmp5_input.z13(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp5_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp5_input.z13(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp5_input.m13(tmp0_desc);
        return EstablishOtp().y4e(tmp3_bitMask0, tmp4_local0, null);
      }
      az() {
        return this.v4e_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [get_nullable(StringSerializer_getInstance())];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
var $serializer_instance_0;
function $serializer_getInstance_0() {
  if ($serializer_instance_0 === VOID)
    new ($serializer_0())();
  return $serializer_instance_0;
}
var EstablishOtpClass;
function EstablishOtp() {
  if (EstablishOtpClass === VOID) {
    class $ {
      constructor(label) {
        label = label === VOID ? null : label;
        this.x4e_1 = label;
      }
      toString() {
        return 'EstablishOtp(label=' + this.x4e_1 + ')';
      }
      hashCode() {
        return this.x4e_1 == null ? 0 : getStringHashCode(this.x4e_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof EstablishOtp()))
          return false;
        if (!(this.x4e_1 == other.x4e_1))
          return false;
        return true;
      }
      static y4e(seen0, label, serializationConstructorMarker) {
        if (!(0 === (0 & seen0))) {
          throwMissingFieldException(seen0, 0, $serializer_getInstance_0().v4e_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.x4e_1 = null;
        else
          $this.x4e_1 = label;
        return $this;
      }
    }
    initMetadataForClass($, 'EstablishOtp', EstablishOtp, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
    EstablishOtpClass = $;
  }
  return EstablishOtpClass;
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance_1();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_2;
function Companion_getInstance_3() {
  return Companion_instance_2;
}
var $serializerClass_1;
function $serializer_1() {
  if ($serializerClass_1 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_1 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.auth.proof.PasswordSecret', this, 9);
        tmp0_serialDesc.c1b('_id', true);
        tmp0_serialDesc.c1b('subjectType', false);
        tmp0_serialDesc.c1b('subjectId', false);
        tmp0_serialDesc.c1b('hash', false);
        tmp0_serialDesc.c1b('hint', true);
        tmp0_serialDesc.c1b('establishedAt', true);
        tmp0_serialDesc.c1b('lastUsedAt', true);
        tmp0_serialDesc.c1b('expiresAt', true);
        tmp0_serialDesc.c1b('disabledAt', true);
        tmp0_serialDesc.e1b(new (IndexSet())(['subjectId', 'subjectType', 'expiresAt', 'disabledAt']));
        this.z4e_1 = tmp0_serialDesc;
      }
      a4f(encoder, value) {
        var tmp0_desc = this.z4e_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.j2u_1.equals(Companion_getInstance_0().m2p())) {
          tmp1_output.c15(tmp0_desc, 0, DeferToContextualUuidSerializer_getInstance(), value.j2u_1);
        }
        tmp1_output.a15(tmp0_desc, 1, value.k2u_1);
        tmp1_output.a15(tmp0_desc, 2, value.l2u_1);
        tmp1_output.a15(tmp0_desc, 3, value.m2u_1);
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !(value.n2u_1 == null)) {
          tmp1_output.d15(tmp0_desc, 4, StringSerializer_getInstance(), value.n2u_1);
        }
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 5)) {
          tmp = true;
        } else {
          // Inline function 'com.lightningkite.now' call
          var tmp$ret$0 = get_default(Companion_instance).d1m();
          tmp = !value.o2u_1.equals(tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.c15(tmp0_desc, 5, InstantIso8601Serializer_getInstance(), value.o2u_1);
        }
        if (tmp1_output.h15(tmp0_desc, 6) ? true : !(value.p2u_1 == null)) {
          tmp1_output.d15(tmp0_desc, 6, InstantIso8601Serializer_getInstance(), value.p2u_1);
        }
        if (tmp1_output.h15(tmp0_desc, 7) ? true : !(value.q2u_1 == null)) {
          tmp1_output.d15(tmp0_desc, 7, InstantIso8601Serializer_getInstance(), value.q2u_1);
        }
        if (tmp1_output.h15(tmp0_desc, 8) ? true : !(value.r2u_1 == null)) {
          tmp1_output.d15(tmp0_desc, 8, InstantIso8601Serializer_getInstance(), value.r2u_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.a4f(encoder, value instanceof PasswordSecret() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.z4e_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_input = decoder.l13(tmp0_desc);
        if (tmp13_input.a14()) {
          tmp4_local0 = tmp13_input.x13(tmp0_desc, 0, DeferToContextualUuidSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp13_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp13_input.v13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp13_input.v13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp13_input.z13(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp13_input.x13(tmp0_desc, 5, InstantIso8601Serializer_getInstance(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp13_input.z13(tmp0_desc, 6, InstantIso8601Serializer_getInstance(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp13_input.z13(tmp0_desc, 7, InstantIso8601Serializer_getInstance(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp13_input.z13(tmp0_desc, 8, InstantIso8601Serializer_getInstance(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp13_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp13_input.x13(tmp0_desc, 0, DeferToContextualUuidSerializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp13_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp13_input.v13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp13_input.v13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp13_input.z13(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp13_input.x13(tmp0_desc, 5, InstantIso8601Serializer_getInstance(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp13_input.z13(tmp0_desc, 6, InstantIso8601Serializer_getInstance(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp13_input.z13(tmp0_desc, 7, InstantIso8601Serializer_getInstance(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp13_input.z13(tmp0_desc, 8, InstantIso8601Serializer_getInstance(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp13_input.m13(tmp0_desc);
        return PasswordSecret().b4f(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, null);
      }
      az() {
        return this.z4e_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [DeferToContextualUuidSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), InstantIso8601Serializer_getInstance(), get_nullable(InstantIso8601Serializer_getInstance()), get_nullable(InstantIso8601Serializer_getInstance()), get_nullable(InstantIso8601Serializer_getInstance())];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_1 = $;
  }
  return $serializerClass_1;
}
var $serializer_instance_1;
function $serializer_getInstance_1() {
  if ($serializer_instance_1 === VOID)
    new ($serializer_1())();
  return $serializer_instance_1;
}
var PasswordSecretClass;
function PasswordSecret() {
  if (PasswordSecretClass === VOID) {
    class $ {
      constructor(_id, subjectType, subjectId, hash, hint, establishedAt, lastUsedAt, expiresAt, disabledAt) {
        _id = _id === VOID ? Companion_getInstance_0().m2p() : _id;
        hint = hint === VOID ? null : hint;
        var tmp;
        if (establishedAt === VOID) {
          // Inline function 'com.lightningkite.now' call
          tmp = get_default(Companion_instance).d1m();
        } else {
          tmp = establishedAt;
        }
        establishedAt = tmp;
        lastUsedAt = lastUsedAt === VOID ? null : lastUsedAt;
        expiresAt = expiresAt === VOID ? null : expiresAt;
        disabledAt = disabledAt === VOID ? null : disabledAt;
        this.j2u_1 = _id;
        this.k2u_1 = subjectType;
        this.l2u_1 = subjectId;
        this.m2u_1 = hash;
        this.n2u_1 = hint;
        this.o2u_1 = establishedAt;
        this.p2u_1 = lastUsedAt;
        this.q2u_1 = expiresAt;
        this.r2u_1 = disabledAt;
      }
      h40() {
        return this.j2u_1;
      }
      c4f(_id, subjectType, subjectId, hash, hint, establishedAt, lastUsedAt, expiresAt, disabledAt) {
        return new (PasswordSecret())(_id, subjectType, subjectId, hash, hint, establishedAt, lastUsedAt, expiresAt, disabledAt);
      }
      t2u(_id, subjectType, subjectId, hash, hint, establishedAt, lastUsedAt, expiresAt, disabledAt, $super) {
        _id = _id === VOID ? this.j2u_1 : _id;
        subjectType = subjectType === VOID ? this.k2u_1 : subjectType;
        subjectId = subjectId === VOID ? this.l2u_1 : subjectId;
        hash = hash === VOID ? this.m2u_1 : hash;
        hint = hint === VOID ? this.n2u_1 : hint;
        establishedAt = establishedAt === VOID ? this.o2u_1 : establishedAt;
        lastUsedAt = lastUsedAt === VOID ? this.p2u_1 : lastUsedAt;
        expiresAt = expiresAt === VOID ? this.q2u_1 : expiresAt;
        disabledAt = disabledAt === VOID ? this.r2u_1 : disabledAt;
        return $super === VOID ? this.c4f(_id, subjectType, subjectId, hash, hint, establishedAt, lastUsedAt, expiresAt, disabledAt) : $super.c4f.call(this, _id, subjectType, subjectId, hash, hint, establishedAt, lastUsedAt, expiresAt, disabledAt);
      }
      toString() {
        return 'PasswordSecret(_id=' + this.j2u_1.toString() + ', subjectType=' + this.k2u_1 + ', subjectId=' + this.l2u_1 + ', hash=' + this.m2u_1 + ', hint=' + this.n2u_1 + ', establishedAt=' + this.o2u_1.toString() + ', lastUsedAt=' + toString(this.p2u_1) + ', expiresAt=' + toString(this.q2u_1) + ', disabledAt=' + toString(this.r2u_1) + ')';
      }
      hashCode() {
        var result = this.j2u_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.k2u_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.l2u_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.m2u_1) | 0;
        result = imul(result, 31) + (this.n2u_1 == null ? 0 : getStringHashCode(this.n2u_1)) | 0;
        result = imul(result, 31) + this.o2u_1.hashCode() | 0;
        result = imul(result, 31) + (this.p2u_1 == null ? 0 : this.p2u_1.hashCode()) | 0;
        result = imul(result, 31) + (this.q2u_1 == null ? 0 : this.q2u_1.hashCode()) | 0;
        result = imul(result, 31) + (this.r2u_1 == null ? 0 : this.r2u_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PasswordSecret()))
          return false;
        if (!this.j2u_1.equals(other.j2u_1))
          return false;
        if (!(this.k2u_1 === other.k2u_1))
          return false;
        if (!(this.l2u_1 === other.l2u_1))
          return false;
        if (!(this.m2u_1 === other.m2u_1))
          return false;
        if (!(this.n2u_1 == other.n2u_1))
          return false;
        if (!this.o2u_1.equals(other.o2u_1))
          return false;
        if (!equals(this.p2u_1, other.p2u_1))
          return false;
        if (!equals(this.q2u_1, other.q2u_1))
          return false;
        if (!equals(this.r2u_1, other.r2u_1))
          return false;
        return true;
      }
      static b4f(seen0, _id, subjectType, subjectId, hash, hint, establishedAt, lastUsedAt, expiresAt, disabledAt, serializationConstructorMarker) {
        if (!(14 === (14 & seen0))) {
          throwMissingFieldException(seen0, 14, $serializer_getInstance_1().z4e_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.j2u_1 = Companion_getInstance_0().m2p();
        else
          $this.j2u_1 = _id;
        $this.k2u_1 = subjectType;
        $this.l2u_1 = subjectId;
        $this.m2u_1 = hash;
        if (0 === (seen0 & 16))
          $this.n2u_1 = null;
        else
          $this.n2u_1 = hint;
        if (0 === (seen0 & 32)) {
          var tmp = $this;
          // Inline function 'com.lightningkite.now' call
          tmp.o2u_1 = get_default(Companion_instance).d1m();
        } else
          $this.o2u_1 = establishedAt;
        if (0 === (seen0 & 64))
          $this.p2u_1 = null;
        else
          $this.p2u_1 = lastUsedAt;
        if (0 === (seen0 & 128))
          $this.q2u_1 = null;
        else
          $this.q2u_1 = expiresAt;
        if (0 === (seen0 & 256))
          $this.r2u_1 = null;
        else
          $this.r2u_1 = disabledAt;
        return $this;
      }
    }
    initMetadataForClass($, 'PasswordSecret', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_1});
    PasswordSecretClass = $;
  }
  return PasswordSecretClass;
}
var CompanionClass_2;
function Companion_2() {
  if (CompanionClass_2 === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance_2();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_2 = $;
  }
  return CompanionClass_2;
}
var Companion_instance_3;
function Companion_getInstance_4() {
  return Companion_instance_3;
}
var $serializerClass_2;
function $serializer_2() {
  if ($serializerClass_2 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_2 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.auth.proof.KnownDeviceSecret', this, 9);
        tmp0_serialDesc.c1b('_id', true);
        tmp0_serialDesc.c1b('subjectType', false);
        tmp0_serialDesc.c1b('subjectId', false);
        tmp0_serialDesc.c1b('hash', false);
        tmp0_serialDesc.c1b('deviceInfo', false);
        tmp0_serialDesc.c1b('establishedAt', true);
        tmp0_serialDesc.c1b('lastUsedAt', true);
        tmp0_serialDesc.c1b('expiresAt', true);
        tmp0_serialDesc.c1b('disabledAt', true);
        tmp0_serialDesc.e1b(new (IndexSet())(['subjectId', 'subjectType', 'expiresAt', 'disabledAt']));
        this.d4f_1 = tmp0_serialDesc;
      }
      e4f(encoder, value) {
        var tmp0_desc = this.d4f_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        if (tmp1_output.h15(tmp0_desc, 0) ? true : !value.o2p_1.equals(Companion_getInstance_0().m2p())) {
          tmp1_output.c15(tmp0_desc, 0, DeferToContextualUuidSerializer_getInstance(), value.o2p_1);
        }
        tmp1_output.a15(tmp0_desc, 1, value.p2p_1);
        tmp1_output.a15(tmp0_desc, 2, value.q2p_1);
        tmp1_output.a15(tmp0_desc, 3, value.r2p_1);
        tmp1_output.a15(tmp0_desc, 4, value.s2p_1);
        var tmp;
        if (tmp1_output.h15(tmp0_desc, 5)) {
          tmp = true;
        } else {
          // Inline function 'com.lightningkite.now' call
          var tmp$ret$0 = get_default(Companion_instance).d1m();
          tmp = !value.t2p_1.equals(tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.c15(tmp0_desc, 5, InstantIso8601Serializer_getInstance(), value.t2p_1);
        }
        if (tmp1_output.h15(tmp0_desc, 6) ? true : !(value.u2p_1 == null)) {
          tmp1_output.d15(tmp0_desc, 6, InstantIso8601Serializer_getInstance(), value.u2p_1);
        }
        if (tmp1_output.h15(tmp0_desc, 7) ? true : !(value.v2p_1 == null)) {
          tmp1_output.d15(tmp0_desc, 7, InstantIso8601Serializer_getInstance(), value.v2p_1);
        }
        if (tmp1_output.h15(tmp0_desc, 8) ? true : !(value.w2p_1 == null)) {
          tmp1_output.d15(tmp0_desc, 8, InstantIso8601Serializer_getInstance(), value.w2p_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.e4f(encoder, value instanceof KnownDeviceSecret() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.d4f_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_input = decoder.l13(tmp0_desc);
        if (tmp13_input.a14()) {
          tmp4_local0 = tmp13_input.x13(tmp0_desc, 0, DeferToContextualUuidSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp13_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp13_input.v13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp13_input.v13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp13_input.v13(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp13_input.x13(tmp0_desc, 5, InstantIso8601Serializer_getInstance(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp13_input.z13(tmp0_desc, 6, InstantIso8601Serializer_getInstance(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp13_input.z13(tmp0_desc, 7, InstantIso8601Serializer_getInstance(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp13_input.z13(tmp0_desc, 8, InstantIso8601Serializer_getInstance(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp13_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp13_input.x13(tmp0_desc, 0, DeferToContextualUuidSerializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp13_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp13_input.v13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp13_input.v13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp13_input.v13(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp13_input.x13(tmp0_desc, 5, InstantIso8601Serializer_getInstance(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp13_input.z13(tmp0_desc, 6, InstantIso8601Serializer_getInstance(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp13_input.z13(tmp0_desc, 7, InstantIso8601Serializer_getInstance(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp13_input.z13(tmp0_desc, 8, InstantIso8601Serializer_getInstance(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp13_input.m13(tmp0_desc);
        return KnownDeviceSecret().f4f(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, null);
      }
      az() {
        return this.d4f_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [DeferToContextualUuidSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), InstantIso8601Serializer_getInstance(), get_nullable(InstantIso8601Serializer_getInstance()), get_nullable(InstantIso8601Serializer_getInstance()), get_nullable(InstantIso8601Serializer_getInstance())];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_2 = $;
  }
  return $serializerClass_2;
}
var $serializer_instance_2;
function $serializer_getInstance_2() {
  if ($serializer_instance_2 === VOID)
    new ($serializer_2())();
  return $serializer_instance_2;
}
var KnownDeviceSecretClass;
function KnownDeviceSecret() {
  if (KnownDeviceSecretClass === VOID) {
    class $ {
      constructor(_id, subjectType, subjectId, hash, deviceInfo, establishedAt, lastUsedAt, expiresAt, disabledAt) {
        _id = _id === VOID ? Companion_getInstance_0().m2p() : _id;
        var tmp;
        if (establishedAt === VOID) {
          // Inline function 'com.lightningkite.now' call
          tmp = get_default(Companion_instance).d1m();
        } else {
          tmp = establishedAt;
        }
        establishedAt = tmp;
        lastUsedAt = lastUsedAt === VOID ? null : lastUsedAt;
        expiresAt = expiresAt === VOID ? null : expiresAt;
        disabledAt = disabledAt === VOID ? null : disabledAt;
        this.o2p_1 = _id;
        this.p2p_1 = subjectType;
        this.q2p_1 = subjectId;
        this.r2p_1 = hash;
        this.s2p_1 = deviceInfo;
        this.t2p_1 = establishedAt;
        this.u2p_1 = lastUsedAt;
        this.v2p_1 = expiresAt;
        this.w2p_1 = disabledAt;
      }
      h40() {
        return this.o2p_1;
      }
      g4f(_id, subjectType, subjectId, hash, deviceInfo, establishedAt, lastUsedAt, expiresAt, disabledAt) {
        return new (KnownDeviceSecret())(_id, subjectType, subjectId, hash, deviceInfo, establishedAt, lastUsedAt, expiresAt, disabledAt);
      }
      y2p(_id, subjectType, subjectId, hash, deviceInfo, establishedAt, lastUsedAt, expiresAt, disabledAt, $super) {
        _id = _id === VOID ? this.o2p_1 : _id;
        subjectType = subjectType === VOID ? this.p2p_1 : subjectType;
        subjectId = subjectId === VOID ? this.q2p_1 : subjectId;
        hash = hash === VOID ? this.r2p_1 : hash;
        deviceInfo = deviceInfo === VOID ? this.s2p_1 : deviceInfo;
        establishedAt = establishedAt === VOID ? this.t2p_1 : establishedAt;
        lastUsedAt = lastUsedAt === VOID ? this.u2p_1 : lastUsedAt;
        expiresAt = expiresAt === VOID ? this.v2p_1 : expiresAt;
        disabledAt = disabledAt === VOID ? this.w2p_1 : disabledAt;
        return $super === VOID ? this.g4f(_id, subjectType, subjectId, hash, deviceInfo, establishedAt, lastUsedAt, expiresAt, disabledAt) : $super.g4f.call(this, _id, subjectType, subjectId, hash, deviceInfo, establishedAt, lastUsedAt, expiresAt, disabledAt);
      }
      toString() {
        return 'KnownDeviceSecret(_id=' + this.o2p_1.toString() + ', subjectType=' + this.p2p_1 + ', subjectId=' + this.q2p_1 + ', hash=' + this.r2p_1 + ', deviceInfo=' + this.s2p_1 + ', establishedAt=' + this.t2p_1.toString() + ', lastUsedAt=' + toString(this.u2p_1) + ', expiresAt=' + toString(this.v2p_1) + ', disabledAt=' + toString(this.w2p_1) + ')';
      }
      hashCode() {
        var result = this.o2p_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.p2p_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.q2p_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.r2p_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.s2p_1) | 0;
        result = imul(result, 31) + this.t2p_1.hashCode() | 0;
        result = imul(result, 31) + (this.u2p_1 == null ? 0 : this.u2p_1.hashCode()) | 0;
        result = imul(result, 31) + (this.v2p_1 == null ? 0 : this.v2p_1.hashCode()) | 0;
        result = imul(result, 31) + (this.w2p_1 == null ? 0 : this.w2p_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof KnownDeviceSecret()))
          return false;
        if (!this.o2p_1.equals(other.o2p_1))
          return false;
        if (!(this.p2p_1 === other.p2p_1))
          return false;
        if (!(this.q2p_1 === other.q2p_1))
          return false;
        if (!(this.r2p_1 === other.r2p_1))
          return false;
        if (!(this.s2p_1 === other.s2p_1))
          return false;
        if (!this.t2p_1.equals(other.t2p_1))
          return false;
        if (!equals(this.u2p_1, other.u2p_1))
          return false;
        if (!equals(this.v2p_1, other.v2p_1))
          return false;
        if (!equals(this.w2p_1, other.w2p_1))
          return false;
        return true;
      }
      static f4f(seen0, _id, subjectType, subjectId, hash, deviceInfo, establishedAt, lastUsedAt, expiresAt, disabledAt, serializationConstructorMarker) {
        if (!(30 === (30 & seen0))) {
          throwMissingFieldException(seen0, 30, $serializer_getInstance_2().d4f_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.o2p_1 = Companion_getInstance_0().m2p();
        else
          $this.o2p_1 = _id;
        $this.p2p_1 = subjectType;
        $this.q2p_1 = subjectId;
        $this.r2p_1 = hash;
        $this.s2p_1 = deviceInfo;
        if (0 === (seen0 & 32)) {
          var tmp = $this;
          // Inline function 'com.lightningkite.now' call
          tmp.t2p_1 = get_default(Companion_instance).d1m();
        } else
          $this.t2p_1 = establishedAt;
        if (0 === (seen0 & 64))
          $this.u2p_1 = null;
        else
          $this.u2p_1 = lastUsedAt;
        if (0 === (seen0 & 128))
          $this.v2p_1 = null;
        else
          $this.v2p_1 = expiresAt;
        if (0 === (seen0 & 256))
          $this.w2p_1 = null;
        else
          $this.w2p_1 = disabledAt;
        return $this;
      }
    }
    initMetadataForClass($, 'KnownDeviceSecret', VOID, VOID, [HasId()], VOID, VOID, {0: $serializer_getInstance_2});
    KnownDeviceSecretClass = $;
  }
  return KnownDeviceSecretClass;
}
var CompanionClass_3;
function Companion_3() {
  if (CompanionClass_3 === VOID) {
    class $ {
      m2a() {
        return $serializer_getInstance_3();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_3 = $;
  }
  return CompanionClass_3;
}
var Companion_instance_4;
function Companion_getInstance_5() {
  return Companion_instance_4;
}
var $serializerClass_3;
function $serializer_3() {
  if ($serializerClass_3 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_3 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.auth.proof.EstablishPassword', this, 2);
        tmp0_serialDesc.c1b('password', false);
        tmp0_serialDesc.c1b('hint', true);
        this.h4f_1 = tmp0_serialDesc;
      }
      i4f(encoder, value) {
        var tmp0_desc = this.h4f_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.a15(tmp0_desc, 0, value.j4f_1);
        if (tmp1_output.h15(tmp0_desc, 1) ? true : !(value.k4f_1 == null)) {
          tmp1_output.d15(tmp0_desc, 1, StringSerializer_getInstance(), value.k4f_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.i4f(encoder, value instanceof EstablishPassword() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.h4f_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.z13(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.z13(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return EstablishPassword().l4f(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.h4f_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_3 = $;
  }
  return $serializerClass_3;
}
var $serializer_instance_3;
function $serializer_getInstance_3() {
  if ($serializer_instance_3 === VOID)
    new ($serializer_3())();
  return $serializer_instance_3;
}
var EstablishPasswordClass;
function EstablishPassword() {
  if (EstablishPasswordClass === VOID) {
    class $ {
      toString() {
        return 'EstablishPassword(password=' + this.j4f_1 + ', hint=' + this.k4f_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.j4f_1);
        result = imul(result, 31) + (this.k4f_1 == null ? 0 : getStringHashCode(this.k4f_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof EstablishPassword()))
          return false;
        if (!(this.j4f_1 === other.j4f_1))
          return false;
        if (!(this.k4f_1 == other.k4f_1))
          return false;
        return true;
      }
      static l4f(seen0, password, hint, serializationConstructorMarker) {
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_3().h4f_1);
        }
        var $this = createThis(this);
        $this.j4f_1 = password;
        if (0 === (seen0 & 2))
          $this.k4f_1 = null;
        else
          $this.k4f_1 = hint;
        return $this;
      }
    }
    initMetadataForClass($, 'EstablishPassword', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_3});
    EstablishPasswordClass = $;
  }
  return EstablishPasswordClass;
}
//region block: init
Companion_instance_1 = new (Companion_0())();
Companion_instance_2 = new (Companion_1())();
Companion_instance_3 = new (Companion_2())();
Companion_instance_4 = new (Companion_3())();
//endregion
//region block: exports
export {
  KnownDeviceSecret as KnownDeviceSecret16p4ozzebnrjy,
  OtpSecret as OtpSecret2919vqlwy0it0,
  PasswordSecret as PasswordSecret36s6jaq76xka2,
  Companion_instance_1 as Companion_instance7fo6qco5btbo,
  Companion_instance_4 as Companion_instance3ewbpovhpt7ut,
  Companion_instance_3 as Companion_instance1fvvx9vzv7oo5,
  Companion_getInstance_1 as Companion_getInstance139kwuiq3xn4y,
  Companion_instance_2 as Companion_instance1a8y12exr3m74,
};
//endregion

//# sourceMappingURL=AuthSecrets.mjs.map
